module.exports = require("@nextcloud/router");